import React from 'react';
import {Link} from "react-router-dom";

const BlogItemList = (props) => {
    return (
        <div className="blog-item">
            <div className="row align-items-center">
                <div className="col-md-5">
                    <figure className="blog-thumb">
                        <Link to="#">
                            <img
                                src={process.env.REACT_APP_BASE_URL + props.thumb}
                                alt={props.title}
                            />
                        </Link>
                    </figure>
                </div>

                <div className="col-md-7">
                    <div className="blog-content">
                        <h2 className="h5"><Link to="#">{props.title}</Link></h2>
                        <p>{props.excerpt}</p>

                        <div className="blog-meta">
                            <Link to="#">نویسنده: {props.postBy}</Link>
                            <Link to="#">{props.date}</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogItemList;
